import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { getDataFromCorpNafath, sendCorpNafathVerification, verifyWathaq } from '../../store/actions/corporateAction';
import { getContentKeyAccToLang, setToken } from '../../utils/utils';
import { useEffect, useRef, useState } from 'react';
import { setClientApplicantId, setClientApplicationId, setClientId, setKsaCorporate, setNafathCode } from '../../store/slices/constantSlice';
import { languages } from '../../config/config';
import { setLanguage } from '../../store/slices/contentSlice';

export default () => {
  const { TextWeight, isArabic } = dynamicfunction();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const { authLoading } = useSelector((state) => state.auth);
  const { authContent } = useSelector((state) => state.content);
  const { nafath_code, client_application_id, client_id } = useSelector((state) => state.constant);

  const [showModal, setShowModal] = useState(false);
  const [isNafathVarified, setIsNafathVerified] = useState(false);

  const doneRef = useRef(false);
  const mountedRef = useRef(true);
  const timerRef = useRef(null);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(authContent?.web_wathq_verification?.data?.attributes, key, isArabic);
  };
  const user = location.state?.data;
  const clientId = client_id || user?.clientId;

  useEffect(() => {
    const accessToken = searchParams.get('accessToken');
    const applicantTypeId = searchParams.get('ApplicantTypeId');
    const clientApplicationId = searchParams.get('ClientApplicationId');
    const clientIdParam = searchParams.get('ClientId');
    const languageId = searchParams.get('languageId');

    if (accessToken) {
      setToken(accessToken);
      dispatch(setClientApplicantId(Number(applicantTypeId)));
      dispatch(setClientApplicationId(Number(clientApplicationId)));
      dispatch(setClientId(clientIdParam ? Number(clientIdParam) : null));
      dispatch(setKsaCorporate(Number(applicantTypeId) === 1067));
      dispatch(setLanguage({ language: languageId === '3' ? languages?.eng : languages?.arb }));
      setSearchParams({}, { replace: true });
    }
  }, []);

  const handleNafathVerification = (values) => {
    const params = `${clientId}&identificationNo=${values?.number}`;

    dispatch(
      sendCorpNafathVerification(params, () => {
        setShowModal(true);
      }),
    );
  };

  const handleSubmit = (values) => {
    const api_data = {
      crNo: values?.crNumber,
      clientId: clientId,
      clientApplicationId: client_application_id,
      unifiedNumber: values?.unifiedNo,
    };
    dispatch(
      verifyWathaq(api_data, () => {
        navigate('/corporate-form');
      }),
    );
  };

  const closeModal = () => {
    clearTimer();
    setShowModal(false);
    dispatch(setNafathCode(null));
  };

  const clearTimer = () => {
    if (timerRef.current !== null) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      clearTimer();
    };
  }, []);

  useEffect(() => {
    if (!showModal || doneRef.current) {
      clearTimer();
      return;
    }

    const checkOnce = () => {
      if (doneRef.current || !mountedRef.current) return;

      dispatch(
        getDataFromCorpNafath(clientId, () => {
          if (doneRef.current || !mountedRef.current) return;

          doneRef.current = true;
          clearTimer();
          dispatch(setNafathCode(null));
          setIsNafathVerified(true);
          setShowModal(false);
        }),
      );
    };

    // Immediate execution
    checkOnce();

    // Start polling
    timerRef.current = setInterval(checkOnce, 10000);

    // Cleanup on dependency change / unmount
    return () => clearTimer();
  }, [showModal, clientId, dispatch]);

  return {
    TextWeight,
    authLoading,
    getContentKey,
    isArabic,
    navigate,
    showModal,
    isNafathVarified,
    handleNafathVerification,
    handleSubmit,
    closeModal,
    nafath_code,
    doneRef,
  };
};
